import Cursor from '../classes/cursor'

export default {
  install(Vue) {
    Vue.prototype.$cursor = new Cursor().init()
  }
}